// extracted by mini-css-extract-plugin
export default {"container":"FeaturedBlogPost_container__hSCTT","image":"FeaturedBlogPost_image__vtodL","content":"FeaturedBlogPost_content__xDKRp"};